import React from 'react';
import logo from '../assets/images/kh_lotto.png';
import DrawingResult from "./drawing-result/DrawingResult";
import ResultWrapper from "./ResultWrapper";
import {useResult} from "../redux/core/context";

const Homepage = () => {
    const {draw} = useResult();
    const isDrawing = !!draw?.drawAt;
    return (
        <>
            <div style={{background: '#F49307'}}>
                <img src={logo} height="80" alt="Khmer Lotto Logo"/>
            </div>
            {
                isDrawing ? <DrawingResult drawingResult={draw}/> : <ResultWrapper/>
            }
        </>
    );
};

export default Homepage;
